module.exports = __webpack_public_path__ + "a4f1f25b5e358b43b289ce13c5830a8f.png";